import * as React from 'react'

import IconButton         from '@material-ui/core/IconButton/IconButton'
import InputAdornment     from '@material-ui/core/InputAdornment/InputAdornment'
import { TextFieldProps } from '@material-ui/core/TextField'
import Visibility         from '@material-ui/icons/Visibility'
import VisibilityOff      from '@material-ui/icons/VisibilityOff'

import EnhancedTextField from './EnhancedTextField'

type PasswordFieldProps = TextFieldProps

export default class extends React.Component<PasswordFieldProps, { passwordVisible: boolean }> {
  public state = {
    passwordVisible: false,
  }

  public render () {
    const { passwordVisible } = this.state
    const type = passwordVisible ? 'text' : 'password'

    return (
      <EnhancedTextField
        type={type}
        InputProps={{
          endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              onClick={this.togglePasswordVisibility}
                            >
                              {passwordVisible ? <Visibility /> : <VisibilityOff />}
                            </IconButton>
                          </InputAdornment>
                        ),
        }}
        {...this.props}
      />
    )
  }

  private togglePasswordVisibility = () => {
    this.setState(state => ({ passwordVisible: !state.passwordVisible }))
  }
}



// WEBPACK FOOTER //
// ./src/components/atoms/PasswordField.tsx